// extracted by mini-css-extract-plugin
module.exports = {"topDestinations":"TopDestinations_topDestinations__2Bwlc","link":"TopDestinations_link__8ULov"};